import React from 'react'
import { getBEMCls } from '@/utils/classname'
import { Expaned } from '@/components/layout/layout'
import Button from '@/components/button/button'

import './staff-apply.scss'
import { observer } from 'mobx-react'
import { shopStore } from '@/store/shop'
import { staffListModel } from '../staff-list/model'
import StaffApplyTable from './staff-apply-table/staff-apply-table'
import { openStaffEntry } from '../staff-entry'

const StaffApply = observer(() => {
    const getCls = (e?: string, m?: string) => getBEMCls('staff-apply', e, m)

    return (
        <>
            <Expaned className={getCls()}>
                <div className={getCls('header')}>
                    <Button
                        types="default"
                        onClick={() => {
                            openStaffEntry({
                                currentVersion: shopStore.currentVersion,
                                staffNum: staffListModel.staffNum,
                                maxStaffNum: staffListModel.maxStaffNum,
                            })
                        }}
                    >
                        添加员工
                    </Button>
                </div>
                <Expaned data-row className={getCls('content')}>
                    <StaffApplyTable />
                </Expaned>
            </Expaned>
        </>
    )
})

export default StaffApply
